/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled from 'styled-components';
import { Icon } from '../../../icon';
import { Button } from '../../../button/Button';
import { LinkButton } from '../../../button/LinkButton';
import { transition } from '../../../themes/mainTheme';

export const ContentSliderCard = styled.div`
	border: 1px solid ${props => props.theme.border.decorative};
	border-radius: 4px;
	background: ${props => props.theme.surface[2]};
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;

export const ContentSliderViewport = styled.div`
	overflow: hidden;
	width: 100%;
`;

export const ContentSliderTrack = styled.div<{ $index: number; $count: number }>`
	display: flex;
	width: ${({ $count }) => $count * 100}%;
	transform: translateX(${({ $index, $count }) => -($index / $count) * 100}%);
	transition: ${transition('transform')};
	will-change: transform;
`;

export const ContentSliderSlide = styled.div<{ $count: number }>`
	width: ${({ $count }) => 100 / $count}%;
	flex-shrink: 0;
	padding: 16px;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
`;

export const ContentSliderWrapper = styled.div`
	position: relative;

	&:hover > button {
		opacity: 1;
	}
`;

export const ContentSliderImageArea = styled.div`
	width: 100%;
	aspect-ratio: 16 / 9;
	border-radius: 4px;
	overflow: hidden;
	background: ${props => props.theme.surface[3]};
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ContentSliderPlaceholderIcon = styled(Icon)`
	font-size: 32px;
	color: ${props => props.theme.text.tertiary};
`;

export const ContentSliderContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding-top: 16px;
	flex: 1;
`;

export const LinkButtonStyled = styled(LinkButton)`
	margin-top: auto;
`;

export const ContentSliderHeading = styled.p`
	font-size: 18px;
	font-weight: 600;
	font-family: ${props => props.theme.font};
	color: ${props => props.theme.text.primary};
	margin: 0;
`;

export const ContentSliderDescription = styled.p`
	font-size: 14px;
	font-family: ${props => props.theme.font};
	color: ${props => props.theme.text.tertiary};
	margin: 0;
	line-height: 1.5;
`;

export const ContentSliderArrow = styled(Button)<{ $dir: 'left' | 'right' }>`
	position: absolute;
	top: 30%;
	transform: translateY(-50%);
	${({ $dir }) => ($dir === 'left' ? 'left: 4px;' : 'right: 4px;')}
	z-index: 2;
	border-radius: 50%;
	opacity: 0;
	transition: ${transition('opacity', 'background')};
`;

export const ContentSliderDotNav = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	padding: 0 16px 16px;
`;

export const ContentSliderDot = styled.button<{ $active: boolean }>`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	border: none;
	padding: 0;
	cursor: pointer;
	background: ${({ $active, theme }) => ($active ? theme.fill.brand : theme.fill.disabled)};
	transition: ${transition('background')};

	&:hover {
		background: ${({ $active, theme }) => ($active ? theme.fill.brand : theme.text.tertiary)};
	}
`;
